var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-notification",class:{ wide: !_vm.formatAmount && _vm.amount >= 99, zero: _vm.isZero }},[_vm._v(" "+_vm._s(_vm.formattedAmount)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }